import { useTranslations } from '@vocab/react';
import { Box, Text } from 'braid-design-system';

import translations from '../../../locales.vocab';

const PayPalDescription = () => {
  const { t } = useTranslations(translations);

  return (
    <Box display="flex">
      <Text>{t('pay.option.paypal.description')}</Text>
    </Box>
  );
};

export default PayPalDescription;
